module.exports = __webpack_public_path__ + "static/img/galleryCourse.4495fa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/galleryCourse.png
// module id = JAdS
// module chunks = 1